import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';

import InfinityScrollLoad from '../components/InfinityScrollLoad';

import { MachineryService } from '../services/Machineries';
import { FieldService } from '../services/Fields';

import { MachineryContents } from '../components/tables/Machinery';
import _slideLoader from '../utilities/slideLoader';
import EventMg from '../utilities/EventManager';
import Helmet from 'react-helmet';
import {
  API_FLAG,
  EXTERNAL_SYSTEM_TYPE,
  GATE_CRANE_MACHINERY_REGISTRATION_MANUAL,
  HEADER_CONSTANTS,
  MAX_MACHINERY_COUNT_DEFAULT,
} from '../utilities/constants';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import { Description } from '../components/Description';
import { QuestionIcon } from '../components/icons/QuestionIcon';
import Tippy from '../components/ReactTippy';
import _dialogLoader from '../utilities/dialogLoader';
import { ConfirmDeleteMachineryDialog } from '../components/modals/MachineryDialog';
import ExportExcelDialog from '../components/modals/ExportExcelDialog';
import PrintUtility from '../utilities/printUtility';
import ImageUtility from '../utilities/imageUtility';
import { messageUtility } from '../utilities/messageUtility';
import Loader from '../components/Loader';
import ErrorImportExcel from '../components/ErrorImportExcel';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { isAfterDate } from './common/MasterParts';
import SessionStorageService from '../services/utilities/SessionStorageService';

const MY_EVENT = {
  LOAD_MACHINERIES: 'load_machineries', // 一覧取得
};

const masterName = '機材';

/**
 * @description 機材一覧画面
 */
export class Machineries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      fieldName: '',
      total: 0,
      loaded: false,
      machineries: [],
      canDrop: false, //ドラッグアンドドロップの状態
      searched: false, //検索の状態
      canDrag: false,
      dragSort: [], //ドラッグアンドドロップの並び順の仮置き場
      searchParam: {
        name: '',
        company_name: '',
      },
      orderParam: {
        order: 'order_number_asc',
      },
      modalVisible: {
        delete: false,
      },
      isOpened: false,
      isSettingId: null,
      formValues: {},
      errors: {},
      isLoading: true, // ロード中フラグ
      selectedList: [],
      isSelectAll: false,
      exportFiles: [],
      maxCraneCount: MAX_MACHINERY_COUNT_DEFAULT,
      messageImportErrors: [],
      hasLinkedIchiPlusMachinery: false,
    };
    this.defaultValues = {
      id: null,
      display_flag: 0,
      name: '',
      spec_form: '',
      company_name: '',
      memo: '',
    };
    this.events = {
      table: {
        edit: this.editMachineries.bind(this),
        selectRow: this.handleSelectedRow,
        selectAll: this.handleSelectedAll,
      },
      form: {
        clearFormValues: this.clearFormValues.bind(this),
        set: this.setFlatData.bind(this),
      },
      modal: {
        handleVisible: this.handleVisible.bind(this),
      },
      //ドラッグアンドドロップ用メソッド
      dnd: {
        onHover: this.onHover.bind(this),
        onBeginDrag: this.onBeginDrag.bind(this),
        onDropped: this.onDropped.bind(this),
        draggable: this.draggable.bind(this),
        orderSubmit: this.eventOrderSubmit.bind(this),
      },
    };
    this.isDeletingFlag = false;
    this.isExportingFlag = false;
    this.isImportingFlag = false;
    this.isRequestingFlag = false;
    this.isSubmittingFlag = false;
    this.isDownloadingFlag = false;
    this.fileButtonRef = React.createRef();
    this.co2ReportFlag = SessionStorageService.getCo2ReportFlag();
    this.schema = Joi.object().keys({
      id: Joi.allow(),
      display_flag: Joi.number().required(),
      name: Joi.string()
        .max(127)
        .required(),
      gate_width: Joi.string()
        .max(8)
        .required(),
      gate_height: Joi.string()
        .max(8)
        .required(),
      memo: Joi.string()
        .max(1000)
        .allow(),
    });
    this.FormNew = {
      state: {},
    };
    // 一覧取得イベント登録
    EventMg.registerEvent(MY_EVENT.LOAD_MACHINERIES);
    EventMg.addEventListener(MY_EVENT.LOAD_MACHINERIES, () => {
      this.setState({
        isSelectAll: false,
        selectedList: [],
        messageImportErrors: [],
      });
      this.setMachineries();
    });
  }

  setFieldNameById(fieldId) {
    if (!fieldId) {
      return;
    }
    FieldService.info(fieldId).then(response => {
      if (response.result) {
        this.setState({ fieldName: response.data.entities.field.name });
      }
    });
  }

  componentDidMount() {
    this.setMachineries(this.state.orderParam, this.state.searchParam);
    this.setFieldNameById(this.state.fieldId);
  }

  componentWillUnmount() {
    EventMg.deleteEvent(MY_EVENT.LOAD_MACHINERIES);
  }

  async setMachineries(orderParam, searchParam, notify) {
    if (this.state.loaded && notify) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    const pageParam = {
      offset: notify ? _.size(this.state.machineries) : 0,
    };
    const fieldId = this.state.fieldId;
    const machineryParams = _.assign(orderParam, searchParam, pageParam);
    if (this.co2ReportFlag) {
      machineryParams.include_co2_flag = API_FLAG.On;
    }
    await MachineryService.list(fieldId, machineryParams).then(resp => {
      if (resp.result) {
        const getMachineries = resp.data.entities.machineries;
        if (_.isEmpty(getMachineries) && notify) {
          this.setState({
            loaded: true,
          });
        } else {
          let machineries = notify ? this.state.machineries : [];
          _.each(getMachineries, machinery => {
            if (
              this.co2ReportFlag &&
              machinery.machine_link_updated_at &&
              isAfterDate(machinery.machine_link_updated_at, machinery.updated_at)
            ) {
              machinery.updated_at = machinery.machine_link_updated_at;
            }
            machineries.push(machinery);
          });
          this.setState({
            machineries: _.cloneDeep(machineries),
            hasLinkedIchiPlusMachinery: _.some(machineries, machinery =>
              _.some(machinery.external_system_machineries, {
                external_system_type: EXTERNAL_SYSTEM_TYPE.ICHI_PLUS,
              })
            ),
            total: resp.data.total,
            loaded: false,
          });
        }
      }
      this.setState({ isLoading: false });
      if (notify) {
        notify();
        return;
      }
    });
  }

  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  clearFormValues = () => {
    this.setState({
      isSettingId: null,
      formValues: this.defaultValues,
      errors: {},
    });
  };

  onChangeSearchParam = e => {
    const searchParam = this.state.searchParam;
    let searched = false;
    searchParam[e.target.name] = e.target.value;
    _.each(searchParam, value => {
      if (value !== '') {
        searched = true;
      }
    });
    this.setState({
      searchParam,
      searched,
      isLoading: true,
      machineries: [],
      hasLinkedIchiPlusMachinery: false,
      isSelectAll: false,
      selectedList: [],
    });
    this.setMachineries(this.state.orderParam, searchParam);
  };

  onClearSearchParam = async () => {
    if (this.isRequestingFlag) {
      return;
    }
    this.isRequestingFlag = true;
    const searchParam = {
      name: '',
      company_name: '',
    };
    this.setState({
      searchParam,
      searched: false,
      isLoading: true,
      machineries: [],
      hasLinkedIchiPlusMachinery: false,
      isSelectAll: false,
      selectedList: [],
    });
    await this.setMachineries(this.state.orderParam, searchParam);
    this.isRequestingFlag = false;
  };

  /**
   * ホバー
   */
  // eslint-disable-next-line no-unused-vars
  onHover(props, monitor, component) {}

  /**
   * ドラッグ開始
   */
  // eslint-disable-next-line no-unused-vars
  onBeginDrag(props, monitor, component) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[0] = props.index;
    this.setState({ dragSort });
  }

  /**
   * ドロップダウン
   */
  // eslint-disable-next-line no-unused-vars
  onDropped(dragProps, dropProps, monitor, dropComponent) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[1] = dropProps.index;
    this.setState({ dragSort });
    this.sortList(...this.state.dragSort);
  }

  /**
   * ドラッグ開始、終了
   */
  draggable(bool) {
    this.setState({ canDrag: bool });
  }

  /**
   * @description 並び順を変更する
   */
  sortList(dragIndex, to_index) {
    const lists = _.cloneDeep(this.state.machineries);
    const formItem = lists[dragIndex];
    if (to_index < dragIndex) {
      lists.splice(to_index, 0, formItem);
      lists.splice(dragIndex + 1, 1);
    } else {
      lists.splice(to_index + 1, 0, formItem);
      lists.splice(dragIndex, 1);
    }
    this.setState({ machineries: lists });
  }

  setFlatData = e => {
    let formValues = this.state.formValues;
    formValues[e.target.name] = e.target.value;
    this.setState({ formValues });
  };

  handleVisible = key => {
    const modalState = {};
    modalState[key] = !this.state.modalVisible[key];
    this.setState({ modalVisible: modalState });
  };

  createMachineries() {
    let machineryData = {
      state: {},
    };
    _slideLoader.show('MachineriesNew', machineryData, this.props.vw);
  }

  editMachineries(machinery) {
    let machineryData = {
      state: {
        id: machinery.id,
      },
    };
    _slideLoader.show('MachineriesEdit', machineryData, this.props.vw);
  }

  eventOrderSubmit = () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const fieldId = this.state.fieldId;
    const items = this.state.machineries;
    const params = { ids: _.map(items, 'id') };
    MachineryService.updateOrder(fieldId, params).then(resp => {
      if (resp.result) {
        this.setMachineries(this.state.orderParam, this.state.searchParam);
      }
    }).finally(() => {
      this.isSubmittingFlag = false;
    });
  };

  /**
   * Handle select checkbox
   * @param { boolean } isSelected
   * @param { number } id
   */
  handleSelectedRow = (isSelected, id) => {
    let selectedList = _.cloneDeep(this.state.selectedList);
    if (isSelected) {
      selectedList.push(id);
    } else {
      selectedList = selectedList.filter(selectedId => selectedId !== id);
    }
    const isSelectAll = _.every(
      this.state.machineries,
      machinery =>
        _.some(machinery.external_system_machineries, {
          external_system_type: EXTERNAL_SYSTEM_TYPE.ICHI_PLUS,
        }) || _.includes(selectedList, machinery.id)
    );
    this.setState({ isSelectAll, selectedList });
  };

  /**
   * Handle select all checkbox
   * @param { boolean } isSelectAll
   */
  handleSelectedAll = isSelectAll => {
    const machineriesExcludeIchiPlus = _.filter(
      this.state.machineries,
      item =>
        !_.some(item.external_system_machineries, {
          external_system_type: EXTERNAL_SYSTEM_TYPE.ICHI_PLUS,
        })
    );
    const selectedList = isSelectAll
      ? _.map(machineriesExcludeIchiPlus, 'id')
      : [];
    this.setState({ isSelectAll, selectedList });
  };

  /**
   * Handle bulk import excel
   * @param { * } file
   */
  handleBulkImportExcel = async file => {
    if (this.isImportingFlag) {
      return;
    }
    this.fileButtonRef.current.value = null;
    const isValidType = await ImageUtility.approvalFileType(file, ['xlsx']);
    const isValidSize = await ImageUtility.fileSizeCheck(file);
    if (!isValidType) {
      return this.showFileErrorDialog(messageUtility.getMessage('E-000-059'));
    }
    if (!isValidSize) {
      return this.showFileErrorDialog(messageUtility.getMessage('E-000-060'));
    }
    this.isImportingFlag = true;
    //show loading wait call api
    Loader.start();
    const { fieldId } = this.state;
    const formData = new FormData();
    formData.append('file', file);
    const response = await MachineryService.bulkImportExcel(fieldId, formData);
    Loader.done();
    this.isImportingFlag = false;
    if (!response.result) {
      return this.setState(
        {
          messageImportErrors: [],
        },
        this.showImportExcelErrorDialog
      );
    }
    const errorCommonMessage = _.get(
      response,
      'data.entities.error_common_message'
    );
    const messageImportErrors =
      _.get(response, 'data.entities.error_messages') || [];
    this.setState(
      {
        messageImportErrors,
      },
      () => {
        if (_.isEmpty(messageImportErrors) && !errorCommonMessage) {
          this.showImportExcelSuccessDialog();
        }
      }
    );
    if (errorCommonMessage) {
      this.showFileErrorDialog(errorCommonMessage);
    }
  };

  /**
   * Get info total and limit crane for export
   */
  getExportExcelFileInfo = async () => {
    if (this.isExportingFlag) {
      return;
    }
    this.isExportingFlag = true;
    const { searchParam, fieldId } = this.state;
    const url = await MachineryService.getUrlExportExcel(fieldId);
    const response = await MachineryService.getExportExcelFileInfo(url, {
      ...searchParam,
      first_request: true,
    });
    this.isExportingFlag = false;
    if (response.result) {
      const { total, limit } = response.data.entities.data;
      this.setState({
        maxMachineryCount: limit || MAX_MACHINERY_COUNT_DEFAULT,
      });
      const totalFilesCount = Math.ceil(total / limit);

      if (totalFilesCount > 1) {
        const files = [];
        for (let i = 0; i < totalFilesCount; i++) {
          const fileParams = {
            ...searchParam,
            limit,
            offset: i * limit,
          };

          let src = url;
          _.each(fileParams, (value, key) => {
            src = src.concat(`&${key}=${encodeURIComponent(value)}`);
          });
          files.push({ id: i + 1, src });
        }
        this.setState({
          exportFiles: files,
        });
        this.showExportExcelDialog();
      } else {
        this.handleExportExcel();
      }
    }
  };

  /**
   * Handle export excel
   * @param { number | null } id
   * @param { string | null } url
   */
  handleExportExcel = async (id = null, url = null) => {
    if (this.isExportingFlag) {
      return;
    }
    this.isExportingFlag = true;
    const { searchParam, maxCraneCount, fieldName, fieldId } = this.state;
    let fileName = `${fieldName}_機材マスタ`;

    if (!url) {
      const fileParams = {
        ...searchParam,
        offset: 0,
        limit: maxCraneCount,
      };
      url = await MachineryService.getUrlExportExcel(fieldId);
      _.each(fileParams, (value, key) => {
        url = url.concat(`&${key}=${encodeURIComponent(value)}`);
      });
      fileName = `${fileName}.xlsx`;
    } else {
      fileName = `${fileName}_${id}.xlsx`;
    }
    const response = await MachineryService.bulkExportExcel(url);
    this.isExportingFlag = false;
    if (response) {
      return PrintUtility.printBlob(response, fileName);
    }
  };

  /**
   * Handle close dialog
   * @param { boolean } isClearErrorImport
   */
  handleCloseDialog = (isClearErrorImport = false) => {
    if (isClearErrorImport === true) {
      this.setState({ messageImportErrors: [] });
    }
    _dialogLoader.close();
  };

  /**
   * Show dialog file import excel error
   * @param { string } message
   */
  showFileErrorDialog = message => {
    _dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('E-001-402'),
      onClose: this.handleCloseDialog,
      message,
    });
  };

  showConfirmDeleteMachineryDialog = () => {
    _dialogLoader.show(ConfirmDeleteMachineryDialog, {
      callback: {
        onCancel: this.handleCloseDialog,
        onConfirm: this.handleBulkDeleteMachinery,
      },
    });
  };

  /**
   * Show dialog delete crane success
   * @param { string } message
   */
  showDeleteMachinerySuccessDialog = message => {
    _dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('I-001-438', masterName),
      message,
      onClose: () => {
        const { orderParam, searchParam } = this.state;
        this.handleCloseDialog();
        this.setState({ isSelectAll: false, selectedList: [] }, () => {
          this.setMachineries(orderParam, searchParam);
        });
      },
    });
  };

  showDeleteMachineryErrorDialog = () => {
    _dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('I-001-448', masterName),
      message: messageUtility.getMessage('E-001-425'),
      onClose: this.handleCloseDialog,
    });
  };

  showImportExcelSuccessDialog = () => {
    _dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('I-001-443', masterName),
      message: messageUtility.getMessage('I-001-444', masterName),
      onClose: () => {
        this.handleCloseDialog();
        this.onClearSearchParam();
      },
    });
  };

  showImportExcelErrorDialog = () => {
    _dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('I-001-447', masterName),
      message: messageUtility.getMessage('E-001-425'),
      onClose: () => this.handleCloseDialog(true),
    });
  };

  showDownloadManualErrorDialog = () => {
    _dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('I-000-168'),
      message: messageUtility.getMessage('E-000-033'),
      onClose: this.handleCloseDialog,
    });
  };

  /**
   * Handle download file manual machinery
   */
  downloadMachineryManual = async () => {
    if (this.isDownloadingFlag) {
      return;
    }
    this.isDownloadingFlag = true;
    await PrintUtility.downloadStaticFilePDF(
      GATE_CRANE_MACHINERY_REGISTRATION_MANUAL.fileCode,
      GATE_CRANE_MACHINERY_REGISTRATION_MANUAL.fileName,
      this.showDownloadManualErrorDialog
    );
    this.isDownloadingFlag = false;
  };

  /**
   * Show dialog multiple export excel
   */
  showExportExcelDialog = () => {
    _dialogLoader.show(ExportExcelDialog, {
      masterName,
      downloadItems: this.state.exportFiles,
      handleDownload: this.handleExportExcel,
      onClose: this.handleCloseDialog,
    });
  };

  /**
   * Handle bulk delete machinery
   */
  handleBulkDeleteMachinery = async () => {
    if (this.isDeletingFlag) {
      return;
    }
    this.isDeletingFlag = true;
    const { fieldId, selectedList } = this.state;
    const response = await MachineryService.bulkDelete(fieldId, {
      machinery_ids: selectedList,
    });
    this.isDeletingFlag = false;
    if (response.result) {
      let message = messageUtility.getMessage('I-001-439', masterName);
      if (_.get(response, 'data.entities.deleted_all_flag') === false) {
        message = messageUtility.getMessage('E-001-424', masterName);
      }
      return this.showDeleteMachinerySuccessDialog(message);
    }
    this.showDeleteMachineryErrorDialog();
  };

  headerMenu = () => {
    if (this.state.canDrag) {
      return (
        <div className='setting-header__item'>
          <button
            className='btn--effective'
            onClick={() => {
              this.events.dnd.orderSubmit();
              this.events.dnd.draggable(false);
            }}
          >
            保存
          </button>
        </div>
      );
    }
    return (
      <div className='setting-header__item'>
        <ul className='btn-menu '>
          <li className='btn-menu__item'>
            <button className='btn' onClick={() => this.createMachineries()}>
              新規作成
            </button>
          </li>
          <li className='btn-menu__item'>
            <button
              className={
                _.isEmpty(this.state.selectedList)
                  ? 'btn--disabled'
                  : 'btn--negative'
              }
              onClick={this.showConfirmDeleteMachineryDialog}
              disabled={_.isEmpty(this.state.selectedList)}
            >
              選択項目を削除
            </button>
          </li>
          <TouchDeviceInvisible>
            <div className='segment-line' />
          </TouchDeviceInvisible>
          <li className='btn-menu__item padding-left'>
            <label htmlFor='machinery-file' className='btn--sub'>
              機材一括取り込み
              <input
                id='machinery-file'
                type='file'
                accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ref={this.fileButtonRef}
                onChange={event =>
                  this.handleBulkImportExcel(event.target.files[0])
                }
              />
            </label>
            <Tippy
              className='tooltip'
              duration={10}
              distance={24}
              arrow='true'
              arrowType='sharp'
              delay={[100, 100]}
              placement='bottom'
              followCursor={true}
              html={
                <div className='tippy-tooltip'>
                  複数の機材情報をExcelファイルからまとめて新規登録することができます。
                </div>
              }
            >
              <div className='tooltip-group'>
                <div className='tooltip-group__icon'>
                  <QuestionIcon className='icon--2x question-icon' />
                </div>
              </div>
            </Tippy>
          </li>
          <li className='btn-menu__item padding-left'>
            <button className='btn--sub' onClick={this.getExportExcelFileInfo}>
              機材一覧を出力
            </button>
            <Tippy
              className='tooltip'
              duration={10}
              distance={24}
              arrow='true'
              arrowType='sharp'
              delay={[100, 100]}
              placement='bottom'
              followCursor={true}
              html={
                <div className='tippy-tooltip'>
                  Buildeeに登録済みの機材情報をExcel形式でダウンロードします。
                  <br />
                  ダウンロードしたExcelファイルは、機材の一括取り込みに使用することができます。
                  <br />
                  出力する機材を指定したい場合は、一覧で検索を行ってからボタンを押してください。
                </div>
              }
            >
              <div className='tooltip-group'>
                <div className='tooltip-group__icon'>
                  <QuestionIcon className='icon--2x question-icon' />
                </div>
              </div>
            </Tippy>
          </li>
        </ul>
        {!this.state.searched && (
          <ul className='btn-menu'>
            <TouchDeviceInvisible>
              <li className='btn-menu__item'>
                <button
                  className='btn--sub'
                  onClick={() => this.events.dnd.draggable(true)}
                >
                  並び順を変更する
                </button>
              </li>
            </TouchDeviceInvisible>
          </ul>
        )}
      </div>
    );
  };

  renderDescription = () => {
    return (
      <Description>
        一括取り込みは新規登録が可能ですが、一括での更新には対応しておりませんのでご注意ください。
        <br />
        取り込む件数によっては時間がかかる場合がございます。
        <br />
        他現場に登録された機材を取り込むためには、Excelファイルの現場独自項目を差し替える必要があります。
        <br />
        一括取り込み機能についての詳細は右記リンクの説明資料をご確認ください。
        <button className='btn-text--sm' onClick={this.downloadMachineryManual}>
          ゲート・揚重機・機材一括取り込み説明資料のダウンロード
        </button>
      </Description>
    );
  };

  render() {
    return (
      <div id='infinityscroll-target' className='setting-main__body Machines'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 機材一覧</title>
        </Helmet>
        <div
          id='setting-header'
          className='setting-header Machines__header-menu'
        >
          {this.headerMenu()}
          {!this.state.canDrag && (
            <React.Fragment>
              {this.renderDescription()}
              {!_.isEmpty(this.state.messageImportErrors) && (
                <ErrorImportExcel
                  messageErrors={this.state.messageImportErrors}
                  onCloseMessage={() =>
                    this.setState({ messageImportErrors: [] })
                  }
                />
              )}
            </React.Fragment>
          )}
          <div className='setting-header__item'>
            <div
              className='search-form'
              style={{
                display: this.state.canDrag ? 'none' : 'inline-block',
              }}
            >
              <div className='search-form__header'>
                <div className='search-form__title'>
                  検索条件（検索結果
                  <span className='bold'>{this.state.total}</span>
                  件)
                </div>
                <button
                  id='setting-search-accordion-toggle'
                  className={
                    this.state.isOpened
                      ? 'accordion__btn show'
                      : 'accordion__btn'
                  }
                  onClick={e => this.handleSearchFormShow(e)}
                />
                <button
                  className='btn-text--sm'
                  onClick={this.onClearSearchParam}
                >
                  検索条件クリア
                </button>
              </div>
              <div
                id='setting-search-accordion'
                className={this.state.isOpened ? 'accordion show' : 'accordion'}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form__group flex-wrap'>
                      <div className='form-element'>
                        <div className='form-element__label'>
                          <span className='label'>機材名称</span>
                        </div>
                        <div className='form-element__element'>
                          <input
                            type='text'
                            placeholder='機材名称'
                            name='name'
                            value={this.state.searchParam.name}
                            onChange={this.onChangeSearchParam}
                            className=''
                          />
                        </div>
                      </div>
                      <div className='form-element'>
                        <div className='form-element__label'>
                          <span className='label'>管理会社</span>
                        </div>
                        <div className='form-element__element'>
                          <input
                            type='text'
                            placeholder='管理会社'
                            name='company_name'
                            value={this.state.searchParam.company_name}
                            onChange={this.onChangeSearchParam}
                            className=''
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MachineryContents
          machineries={this.state.machineries}
          values={this.state.formValues}
          errors={this.state.errors}
          isSettingId={this.state.isSettingId}
          callbacks={this.events}
          canDrag={this.state.canDrag}
          selectedList={this.state.selectedList}
          isSelectAll={this.state.isSelectAll}
          hasLinkedIchiPlusMachinery={this.state.hasLinkedIchiPlusMachinery}
          infinityScrollLoad={
            <InfinityScrollLoad
              targetId='infinityscroll-target'
              total={_.size(this.state.machineries)}
              isLoading={this.state.isLoading}
              callback={notifyEnd => {
                this.setMachineries(
                  this.state.orderParam,
                  this.state.searchParam,
                  notifyEnd
                );
              }}
            />
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Machineries.jsx